<template>
  <div id="app">
    <div
      id="nav"
      fluid
      class="mb-4"
    >
      <SiteHeader />    
      <Navigation />
    </div>
    <router-view/>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import Navigation from '@/components/Navigation'
import SiteHeader from '@/components/Site-header'

export default {
  components: {
    SiteHeader,
    Navigation
  },
  methods: {
    ...mapActions([
      'fetchArtists',
      'fetchPages',
      'fetchStaticParts'
    ])
  },
  created () {
    this['fetchStaticParts']()
    this['fetchArtists']()
    this['fetchPages']()
  }
}
</script>
<style lang="scss">

</style>
